module.exports = __webpack_public_path__ + "img/visible-hands-logo.d85004c7.svg";